import {FmlxIcon} from 'fmlx-common-ui';
import FastButton from 'components/FastButton';
import PropTypes from 'prop-types';
import {Size, Type, Variant} from 'constants/UIComponentEnum';
import TaskListCheckbox from '../../Components/TaskListCheckbox';

function TaskAction({onEdit, onDelete, isIgnored, onIgnoreCheckboxChanged}) {
  const elementSpace = [];
  if (!onEdit) elementSpace.push(<div />);
  if (!onDelete) elementSpace.push(<div />);
  if (!onIgnoreCheckboxChanged) elementSpace.push(<div />);
  const actionElement = (
    <>
      {onEdit && (
        <FastButton
          onlyIcon
          icon={<FmlxIcon name="Pencil" size={Size.XS} />}
          variant={Variant.PLAIN}
          type={Type.BASIC}
          size={Size.XS}
          withTooltip={false}
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        />
      )}
      {onDelete && (
        <FastButton
          onlyIcon
          icon={<FmlxIcon name="Trash" size={Size.XS} />}
          variant={Variant.PLAIN}
          type={Type.BASIC}
          size={Size.XS}
          withTooltip={false}
          onClick={(e) => {
            onDelete();
            e.stopPropagation();
          }}
        />
      )}
      {onIgnoreCheckboxChanged && (
        <TaskListCheckbox checked={!isIgnored} onChange={(e) => onIgnoreCheckboxChanged(e.target.checked)} />
      )}
    </>
  );

  return (
    <>
      {elementSpace.map((i) => i)}
      {actionElement}
    </>
  );
}

TaskAction.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onIgnoreCheckboxChanged: PropTypes.func,
  isIgnored: PropTypes.bool,
};

TaskAction.defaultProps = {
  onEdit: null,
  onDelete: null,
  onIgnoreCheckboxChanged: null,
  isIgnored: false,
};

export default TaskAction;
